
<ng-container *ngIf="{
    row: columnData | async
  } as $">
<span  *ngIf="$.row && $.row.contract_term>0;else dash">{{$.row.contract_term}}</span>
<ng-template #dash>-</ng-template>
</ng-container>